import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/AuthContext";
import Layout from "./components/Layout";
import ThemeFixer from "./components/ThemeFixer";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import EntityManager from "./pages/EntityManager";
import Securities from "./pages/Securities";
import Deals from "./pages/Deals";
import Positions from "./pages/Positions";
import TradeBlotter from "./pages/TradeBlotter";
import CashWaterfall from "./pages/CashWaterfall";
import DealSetupWizard from "./pages/DealSetupWizard";
import Ledger from "./pages/Ledger";
import ElocFacilities from "./pages/ElocFacilities";
import ElocDraws from "./pages/ElocDraws";
import Investors from "./pages/Investors";
import BankFeed from "./pages/BankFeed";
import PrimeBroker from "./pages/PrimeBroker";
import Settings from "./pages/Settings";
import NAVDashboard from "./pages/NAVDashboard";
import CashRepatriation from "./pages/CashRepatriation";
import DealReports from "./pages/DealReports";
import DataPipeline from "./pages/DataPipeline";
import FeeManager from "./pages/FeeManager";
import WarrantTracker from "./pages/WarrantTracker";
import NoticeReview from "./pages/NoticeReview";
import Approvals from "./pages/Approvals";
import CapitalCalls from "./pages/CapitalCalls";
import Reports from "./pages/Reports";
import TeamManagement from "./pages/TeamManagement";
import DealTeam from "./pages/DealTeam";
import Signup from "./pages/Signup";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeFixer />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/nav" element={<NAVDashboard />} />
            <Route path="/cash-owed" element={<CashRepatriation />} />
            {/* The page was called Cash Repatriation until 21 September 2026.
                Anyone holding a link to the old path still lands on it. */}
            <Route path="/cash-repatriation" element={<Navigate to="/cash-owed" replace />} />
            <Route path="/deal-reports" element={<DealReports />} />
            {/* One deal's report on its own address, so the Dashboard, the
                search and the deal list can link straight to it (usability
                review of 23 October 2026, items 3 and 22). */}
            <Route path="/deal-reports/:dealId" element={<DealReports />} />
            <Route path="/data-pipeline" element={<DataPipeline />} />
            <Route path="/notice-review" element={<NoticeReview />} />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/entities" element={<EntityManager />} />
            <Route path="/securities" element={<Securities />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/positions" element={<Positions />} />
            <Route path="/warrants" element={<WarrantTracker />} />
            <Route path="/trade-blotter" element={<TradeBlotter />} />
            <Route path="/cash-waterfall" element={<CashWaterfall />} />
            <Route path="/deal-wizard" element={<DealSetupWizard />} />
            <Route path="/eloc-facilities" element={<ElocFacilities />} />
            <Route path="/eloc-draws" element={<ElocDraws />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/capital-calls" element={<CapitalCalls />} />
            <Route path="/fee-structure" element={<FeeManager />} />
            <Route path="/bank-feed" element={<BankFeed />} />
            <Route path="/prime-broker" element={<PrimeBroker />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/team" element={<TeamManagement />} />
            <Route path="/deal-team" element={<DealTeam />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
